import fetch from 'isomorphic-fetch'
import { URL } from '../constants/api'

function getDefaultHeaders() {
  return {
  'Content-Type': 'application/json'
  }
}

const request = function(url, method = 'GET', body) {
  return new Promise(function(resolve, reject) {
    fetch(url, {
      method: method,
      headers: getDefaultHeaders(),
      body: JSON.stringify(body)
    }).then(function(response) {
      response.json().then(function(data){
        if (response.ok)
          resolve(data)
        else
          reject(data)
      })
    }).catch(function(err){
      reject([err.toString()])
    })
  })
}

export default {
  fetchCategories() {
    var ENDPOINT = URL + 'properties/categories'
    return request(ENDPOINT, 'GET')
  },
  fetchPlants() {
    var ENDPOINT = URL + 'properties/floor_types'
    return request(ENDPOINT, 'GET')
  }
}




// WEBPACK FOOTER //
// ./src/api/office.js